import React, { useEffect } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import useStyles from "../styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography
} from "@material-ui/core";
import CheckboxWithLabel from "Components/formControls/CheckboxWithLabel";
import { ExpandMore, Check, Close } from "@material-ui/icons";
import { checkArrayLength } from "src/utils";
import { useRecoilValue } from "recoil";
import { metaDataDetails } from "Recoil/LoggedInUserDetail/selector";

const Checkin = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    watch,
    setValue,
  } = useFormContext();
  const { features, disabledView } = watch();
  const name = "features.checkin";
  const { checkin } = useRecoilValue(metaDataDetails);

  const onCheckBoxChange = (e, i) => {
    const { checked } = get(e, "target");
    setValue(`${name}.${i}.isEnabled`, checked);
  };

  useEffect(() => {
    if (!checkArrayLength(features?.checkin) && checkArrayLength(checkin)) {
      const checkinValue = [...checkin].map(res => {
        return {
          name: res.name,
          value: res.value,
          isEnabled: true,
          type: res.name
        };
      });
      setValue(name, checkinValue);
    }
  }, [checkArrayLength(features?.checkin), checkArrayLength(checkin)]);

  return (
    <>
      <Box className={classes.root}>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel2a-content"
            id="panel2a-header"
            className={classes.accordionSummary}>
            <Typography className={classes.heading}>
              {t("companySetup.feature.checkins")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            {get(features, "checkin", []).map((checkin, i) => (
              <Box>
                {disabledView ? (
                  <ul className={classes.qusList}>
                    <li>
                      <span>
                        {checkin.isEnabled ? <Check fontSize="small" className={classes.checkIcon} /> : <Close fontSize="small" className={classes.crossIcon} />}
                      </span>
                      <span className={checkin.isEnabled ? "" : classes.crossIcon}>{checkin.value}</span>
                    </li>
                  </ul>
                ) : <CheckboxWithLabel
                  register={register(`${name}.${i}.isEnabled`)}
                  label={checkin.value}
                  checked={checkin.isEnabled}
                  name={name}
                  handleChange={e => onCheckBoxChange(e, i)}
                // disabled={disabledView}
                />}
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};
export default Checkin;
